<template>
  <div class="card">
    <div class="card-header">
      <strong>Taxonomy</strong>
    </div>
    <div class="card-body form-horizontal">
      <div class="row">
        <div class="col-12">
          <div class="card-block">
            <div v-if="choosen.terms && choosen.terms.length" class="terms-list">
              <div
                v-for="vocabulary in choosen.vocabularies"
                :key="vocabulary.id"
                class="terms-group form-group clearfix"
              >
                <label class="terms-group-name pull-left">
                  Vocabulary
                  <strong>"{{ vocabulary.name }}":</strong>
                </label>
                <template v-for="term in choosen.terms">
                  <span
                    v-if="term.vocabularyId === vocabulary.id"
                    :key="term.id"
                    class="terms-badge badge badge-pill badge-info"
                  >
                    {{ term.name }}
                    <span class="badge-delete-icon terms-badge-close" @click="deleteTerm(term.id)">
                      <i class="fa fa-times" />
                    </span>
                  </span>
                </template>
              </div>
            </div>

            <div class="form-group row">
              <label class="col-md-2">Vocabulary</label>
              <div class="col-md-10">
                <select-remote
                  v-model="newTerm.vocabulary"
                  :default-options="vocabulariesOptionsDefault"
                  :search-function="vocabularySearch"
                  label="name"
                />
              </div>
            </div>

            <div v-if="newTerm.vocabulary" class="form-group row">
              <label class="col-md-2">Terms</label>
              <div class="col-md-10">
                <spinner v-if="termsLoading" size="sm" style="display: block;" />
                <vue-select
                  ref="refTermsModel"
                  v-model="newTerm.terms"
                  multiple
                  :filterable="false"
                  :options="newTerm.termsOptions"
                  label="id"
                  @search="onTermsSearch"
                >
                  <template slot="no-options">
                    type to search...
                  </template>
                  <template slot="option" slot-scope="option">
                    {{ option.name }}
                  </template>
                  <template slot="selected-option" slot-scope="option">
                    {{ option.name }}
                  </template>
                </vue-select>
              </div>
            </div>

            <div
              v-if="newTerm.vocabulary && newTerm.terms && newTerm.terms.length"
              class="form-group row"
            >
              <div class="col-md-12">
                <button class="btn btn-success" @click="addNewTerms">Add</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash';
import VueSelect from 'vue-select';
import SelectRemote from '@/global/components/SelectRemote';

export default {
  name: 'TermsEditor',

  components: {
    'vue-select': VueSelect,
    'select-remote': SelectRemote,
  },

  props: {
    alreadyChoosenTerms: {
      type: Array,
      default: () => [],
    },
  },

  data() {
    return {
      newTerm: {
        vocabulariesOptions: [],
        vocabulary: null,
        termsOptions: [],
        terms: [],
      },
      choosen: {
        terms: [],
        vocabularies: [],
      },
      vocabulariesOptionsDefault: [],
      termsLoading: false,
    };
  },
  
  watch: {
    'newTerm.vocabulary': function () {
      this.newTerm.termsOptions = [];
      this.newTerm.terms = [];
      if (this.$refs.refTermsModel) {
        this.$refs.refTermsModel.onEscape();
      };
      this.getDefaultTerms();
    },
    'choosen.terms': function (newVal) {
      if (newVal && newVal.length) {
        const vocabulariesList = [];
        for (let i = 0; i < newVal.length; i += 1) {
          vocabulariesList.push({
            id: newVal[i].vocabularyId,
            name: newVal[i].vocabularyName,
          });
        }
        this.choosen.vocabularies = _.uniqBy(vocabulariesList, 'id');
      }
    },
  },

  mounted() {
    this.getDefaultVocabularies();

    if (this.alreadyChoosenTerms && this.alreadyChoosenTerms.length) {
      for (let i = 0; i < this.alreadyChoosenTerms.length; i += 1) {
        const obj = {
          id: this.alreadyChoosenTerms[i].id,
          name: this.alreadyChoosenTerms[i].name,
          vocabularyId: this.alreadyChoosenTerms[i].vocabulary_id,
          vocabularyName: this.alreadyChoosenTerms[i].vocabulary.name,
        };
        this.choosen.terms.push(obj);
      }
    };
  },

  methods: {
    vocabularySearch: _.debounce((loading, search, vm) => {
      const context = vm;
      vm.$apiHttp.get(`${vm.$config.app_api.prefix}vocabularies?search_string=${escape(search)}`)
        .then((response) => {
          const newDataArr = _.cloneDeep(response.data);
          delete newDataArr.meta;
          context.options = Object.keys(newDataArr).map(e => newDataArr[e]);
          loading(false);
        })
        .catch((reject) => {
          loading(false);
          console.error(reject);
        });
    }, 350),
    getDefaultVocabularies() {
      this.$apiHttp.get(`${this.$config.app_api.prefix}vocabularies`, { useCache: true })
        .then((response) => {
          const newDataArr = _.cloneDeep(response.data);
          delete newDataArr.meta;
          this.vocabulariesOptionsDefault = Object.keys(newDataArr).map(e => newDataArr[e]);
        })
        .catch((reject) => {
          console.error(reject);
        });
    },
    getDefaultTerms() {
      this.termsLoading = true;
      const VOC_ID = this.newTerm.vocabulary.id;
      this.$apiHttp.get(`${this.$config.app_api.prefix}vocabularies/${VOC_ID}/terms`, { useCache: true })
        .then((response) => {
          const newDataArr = _.cloneDeep(response.data);
          delete newDataArr.meta;
          this.newTerm.termsOptions = Object.keys(newDataArr).map(e => newDataArr[e]);
          this.termsLoading = false;
        })
        .catch((reject) => {
          console.error(reject);
          this.termsLoading = false;
        });
    },
    onTermsSearch(search, loading) {
      loading(true);
      this.termsSearch(loading, search, this);
    },
    termsSearch: _.debounce((loading, search, vm) => {
      const context = vm;
      vm.$apiHttp.get(`${vm.$config.app_api.host + vm.$config.app_api.prefix}terms`, {
        params: {
          vid: vm.newTerm.vocabulary.id,
          search_string: escape(search),
        },
      }).then((response) => {
        const newDataArr = [];
        _.forIn(response.data, (value, key) => {
          if (key !== 'meta') {
            newDataArr.push(value);
          }
        });
        context.newTerm.termsOptions = newDataArr;
        loading(false);
      }).catch((reject) => {
        loading(false);
        console.error(reject);
      });
    }, 350),
    addNewTerms() {
      for (let i = 0; i < this.newTerm.terms.length; i += 1) {
        const obj = {
          id: this.newTerm.terms[i].id,
          name: this.newTerm.terms[i].name,
          vocabularyId: this.newTerm.vocabulary.id,
          vocabularyName: this.newTerm.vocabulary.name,
        };
        if (_.findIndex(this.choosen.terms, item => item.id === obj.id) === -1) {
          this.choosen.terms.push(obj);
        }
      }
      this.newTerm.terms = [];
      this.getDefaultTerms();
      this.newTerm.termsOptions = [];

      this.$emit('changeTerms', this.choosen.terms);
    },
    deleteTerm(elemId) {
      _.remove(this.choosen.terms, item => item.id === elemId);
      this.$forceUpdate();
      this.$emit('changeTerms', this.choosen.terms);
    },
  },
};
</script>



// WEBPACK FOOTER //
// TermsEditor.vue?0661fda8